import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
export const getPaymentPlans = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.get(`/payment-plans${formatPayloadToQueryString(payload)}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar planos de pagamento', error);
        throw error;
    }
};
export const getPaymentPlanById = async (paymentPlanId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/payment-plans/${paymentPlanId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar plano de pagamento', error);
        throw error;
    }
};
export const createPaymentPlan = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/payment-plans', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao criar plano de pagamento', error);
        throw error;
    }
};
export const updatePaymentPlan = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.put(`/payment-plans/${payload.id}`, payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar plano de pagamento', error);
        throw error;
    }
};
export const deletePaymentPlan = async (paymentPlanId, userToken) => {
    try {
        await CoursesApiService.delete(`/payment-plans/${paymentPlanId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao deletar plano de pagamento', error);
        throw error;
    }
};
export const duplicatePaymentPlan = async (paymentPlanId, userToken) => {
    try {
        const response = await CoursesApiService.post(`/payment-plans/${paymentPlanId}/duplicate`, {}, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao duplicar plano de pagamento', error);
        throw error;
    }
};
export const getPaymentPlanMethods = async (paymentPlanId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/payment-plans/${paymentPlanId}/payment-methods`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar métodos do plano de pagamento', error);
        throw error;
    }
};
export const attachPaymentMethod = async (paymentPlanId, paymentMethodId, userToken) => {
    try {
        const response = await CoursesApiService.post(`/payment-plans/${paymentPlanId}/payment-methods`, { payment_method_id: paymentMethodId }, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao vincular método de pagamento ao plano', error);
        throw error;
    }
};
export const detachPaymentMethod = async (paymentPlanId, paymentMethodId, userToken) => {
    try {
        const response = await CoursesApiService.delete(`/payment-plans/${paymentPlanId}/payment-methods/${paymentMethodId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao desvincular método de pagamento do plano', error);
        throw error;
    }
};
export default {
    getPaymentPlans,
    getPaymentPlanById,
    createPaymentPlan,
    updatePaymentPlan,
    deletePaymentPlan,
    duplicatePaymentPlan,
    getPaymentPlanMethods,
    attachPaymentMethod,
    detachPaymentMethod
};
